/**
 * CoreUI CModal sets `document.body` overflow hidden and `padding-right: 0`, which removes
 * the classic vertical scrollbar gutter and shifts fixed-width chrome (e.g. header).
 * Restore padding equal to the gutter while scroll-lock classes are active.
 * Complements `scrollbar-gutter: stable` on `html` where supported.
 */
export function initScrollLockLayoutAlign() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return
  }

  const scrollBarWidth = () =>
    Math.max(0, window.innerWidth - document.documentElement.clientWidth)

  const isScrollLocked = () =>
    document.body.classList.contains("modal-open") ||
    document.body.classList.contains("overflow-hidden")

  const apply = () => {
    requestAnimationFrame(() => {
      const w = scrollBarWidth()
      if (isScrollLocked() && w > 0) {
        document.body.style.paddingRight = `${w}px`
      } else {
        document.body.style.removeProperty("padding-right")
      }
    })
  }

  const observer = new MutationObserver(apply)
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ["class"]
  })

  window.addEventListener("resize", apply)
}
